    export enum SEBType
    {
        England = 981360000,
        Scotland = 981360001,
        Wales = 981360002,
        NorthernIreland = 981360003,
        NottinghamIntegratedMPharm = 981360004,
        UCLIntegratedMPharm = 981360005,
        Other = 981360006
    }